import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, RefreshCwIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="pt-6 pb-12 md:py-16 px-4 relative overflow-hidden" data-id="element-99">
      {/* Animated gradient divider top */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#0ea5e9]/50 to-transparent" data-id="element-100" />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-[#0ea5e9]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-101" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-103">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#0ea5e9]/10 text-[#00d4ff] mb-8 box-glow" data-id="element-104">
            <ActivityIcon className="w-8 h-8" data-id="element-105" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-106">
            La verdadera calma no es mística,
            <br data-id="element-107" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-white" data-id="element-108">
              es biofísica.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto space-y-6 text-lg text-gray-400" data-id="element-109">
            <p data-id="element-110">
              La mayoría de los gurús te dicen que "medites 20 minutos al día".{' '}
              <strong className="text-white" data-id="element-111">
                Eso es imposible para alguien con una responsabilidad real.
              </strong>
            </p>
            <p data-id="element-112">
              Descubrimos que al estimular manualmente el{' '}
              <strong className="text-[#00d4ff]" data-id="element-113">Nervio Vago</strong> mediante
              protocolos específicos de respiración y visión periférica, puedes
              "forzar" a tu cerebro a salir del estado de pánico en menos de 600
              segundos.
            </p>

            <div className="mt-12 p-6 rounded-2xl bg-white/5 border border-white/10 flex items-start gap-4 text-left" data-id="element-114">
              <RefreshCwIcon className="w-6 h-6 text-[#0ea5e9] flex-shrink-0 mt-1" data-id="element-115" />
              <p className="text-white font-medium" data-id="element-116">
                Es como apretar el botón de "Reset" en una computadora trabada.
                No es magia, es ingeniería humana.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}